import { DataResponseReportConfig, ReportConfig, ReportConfigCreateRequest, ReportConfigSearchRequest, ReportConfigUpdateRequest } from "@bluefalcon/clients-management-client-fetch";
import { falconClients } from "../clients/falcon.client";

export class ReportConfigService {

    async createReportConfig(data: ReportConfigCreateRequest): Promise<ReportConfig> {
        return falconClients.reportConfigs.createReportConfig({
            reportConfigCreateRequest: data,
        });
    }

    async updateReportConfigById(id: number, data: ReportConfigUpdateRequest): Promise<ReportConfig> {
        return falconClients.reportConfigs.updateReportConfigById({
            id,
            reportConfigUpdateRequest: data,
        });
    }

    async searchReportConfigs(data: ReportConfigSearchRequest): Promise<DataResponseReportConfig> {
        return falconClients.reportConfigs.searchReportConfigs({
            reportConfigSearchRequest: data,
        });
    }

    async deleteReportConfigById(id: number): Promise<void> {
        return falconClients.reportConfigs.deleteReportConfigById({
            id,
        });
    }
}